import { apiClient } from './api';
import type { ApiResponse } from '@/types';

export interface ReferralCodeInfo {
  id: string;
  code: string;
  slug: string;
  campaign_name: string;
  reward_type: string;
  reward_value: number;
  campaign_discount_type?: string;
  is_active: boolean;
}

export interface ReferralStat {
  campaign_id: string;
  campaign_name: string;
  total: number;
  pending: number;
  completed: number;
  rewarded: number;
  expired: number;
}

class ReferralService {
  async getMyCodes(): Promise<ReferralCodeInfo[]> {
    const response = await apiClient.get<ApiResponse<{ codes: ReferralCodeInfo[] }>>('/referrals/my-codes');
    return response.data.data?.codes || [];
  }

  async getStats(): Promise<ReferralStat[]> {
    const response = await apiClient.get<ApiResponse<{ stats: ReferralStat[] }>>('/referrals/stats');
    return response.data.data?.stats || [];
  }

  async validateSlug(slug: string): Promise<{ valid: boolean; code?: string }> {
    const response = await apiClient.get<ApiResponse<{ valid: boolean; code?: string }>>(`/referrals/validate-slug/${slug}`);
    return response.data.data || { valid: false };
  }
}

export const referralService = new ReferralService();
